import React from 'react'
import { Content as RoomInformation } from 'components/RoomInformation'
import * as styles from './style.module.scss'

/**
 *
 */
export const CurrentRoomInformation = () => {
  return <RoomInformation classNameContainer={styles.Container} />
}
